<template>
  <section id="contact" class="contact">
    <div class="container">
      <div class="section-header">
        <h2 class="section-title">联系我们</h2>
        <p class="section-subtitle">欢迎咨询合作，我们将尽快与您联系</p>
      </div>
      <div class="contact-content">
        <div class="contact-info">
          <h3 class="contact-info-title">联系方式</h3>
          <div class="contact-item">
            <div class="contact-icon">📍</div>
            <div class="contact-text">
              <strong>公司地址</strong>
              <p>河北省石家庄市（具体地址请咨询）</p>
            </div>
          </div>
          <div class="contact-item">
            <div class="contact-icon">🕒</div>
            <div class="contact-text">
              <strong>工作时间</strong>
              <p>周一至周五 9:00-18:00</p>
            </div>
          </div>
        </div>
        <div class="contact-form">
          <h3 class="form-title">在线留言</h3>
          <form @submit.prevent="submitForm">
            <div class="form-group">
              <label for="name">姓名</label>
              <input type="text" id="name" v-model="form.name" required placeholder="请输入您的姓名" />
            </div>
            <div class="form-group">
              <label for="phone">电话</label>
              <input type="tel" id="phone" v-model="form.phone" required placeholder="请输入您的联系电话" />
            </div>
            <div class="form-group">
              <label for="email">邮箱</label>
              <input type="email" id="email" v-model="form.email" required placeholder="请输入您的电子邮箱" />
            </div>
            <div class="form-group">
              <label for="message">留言内容</label>
              <textarea id="message" v-model="form.message" rows="5" required placeholder="请简要描述您的需求或问题"></textarea>
            </div>
            <button type="submit" class="btn-submit" :disabled="submitting">
              {{ submitting ? '提交中...' : '提交留言' }}
            </button>
          </form>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: 'AppContact',
  data() {
    return {
      form: {
        name: '',
        phone: '',
        email: '',
        message: ''
      },
      submitting: false
    };
  },
  methods: {
    submitForm() {
      if (this.submitting) return;
      this.submitting = true;
      // 模拟提交
      setTimeout(() => {
        alert('感谢您的留言！我们会尽快与您联系。');
        this.form = {
          name: '',
          phone: '',
          email: '',
          message: ''
        };
        this.submitting = false;
      }, 1000);
    }
  }
};
</script>

<style scoped>
.contact {
  padding: 5rem 2rem;
  background-color: #f8fafc;
}

.container {
  max-width: 1200px;
  margin: 0 auto;
}

.section-header {
  text-align: center;
  margin-bottom: 3rem;
}

.section-title {
  font-size: 2.5rem;
  font-weight: 700;
  color: #1E5AA8;
  margin-bottom: 1rem;
}

.section-subtitle {
  font-size: 1.2rem;
  color: #666;
  max-width: 700px;
  margin: 0 auto;
  line-height: 1.6;
}

.contact-content {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 4rem;
}

.contact-info-title {
  font-size: 1.8rem;
  font-weight: 700;
  color: #1E5AA8;
  margin-bottom: 2rem;
}

.contact-item {
  display: flex;
  gap: 1.5rem;
  margin-bottom: 2rem;
  align-items: flex-start;
}

.contact-icon {
  font-size: 2rem;
  flex-shrink: 0;
}

.contact-text strong {
  display: block;
  font-size: 1.1rem;
  color: #333;
  margin-bottom: 0.3rem;
}

.contact-text p {
  color: #666;
  line-height: 1.6;
}

.contact-form {
  background: white;
  border-radius: 16px;
  padding: 2.5rem;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.08);
}

.form-title {
  font-size: 1.8rem;
  font-weight: 700;
  color: #1E5AA8;
  margin-bottom: 2rem;
}

.form-group {
  margin-bottom: 1.5rem;
}

.form-group label {
  display: block;
  font-weight: 600;
  color: #444;
  margin-bottom: 0.5rem;
}

.form-group input,
.form-group textarea {
  width: 100%;
  padding: 0.875rem 1rem;
  border: 1px solid #ddd;
  border-radius: 8px;
  font-size: 1rem;
  transition: border 0.3s;
  box-sizing: border-box;
}

.form-group input:focus,
.form-group textarea:focus {
  outline: none;
  border-color: #1E5AA8;
  box-shadow: 0 0 0 3px rgba(30, 90, 168, 0.1);
}

.btn-submit {
  width: 100%;
  padding: 1rem;
  background: #1E5AA8;
  color: white;
  border: none;
  border-radius: 8px;
  font-size: 1.1rem;
  font-weight: 600;
  cursor: pointer;
  transition: background 0.3s;
}

.btn-submit:hover:not(:disabled) {
  background: #0A2647;
}

.btn-submit:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

@media (max-width: 992px) {
  .contact-content {
    grid-template-columns: 1fr;
    gap: 3rem;
  }
}

@media (max-width: 576px) {
  .contact {
    padding: 3rem 1.5rem;
  }
  .contact-form {
    padding: 2rem 1.5rem;
  }
}
</style>
